import { Icon } from '@livable/saas-react-components';
import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isOccupancyBasedAllocationMethod, VACANT_UNIT_OCCUPANTS_COUNT, VACANT_UNIT_USAGE } from 'src/constants/utilities';
import { useStore } from 'src/stores';
import useStyles from './styles';
const COUNTS = Array.from({
  length: VACANT_UNIT_OCCUPANTS_COUNT.max - VACANT_UNIT_OCCUPANTS_COUNT.min + 1
}, (_, index) => VACANT_UNIT_OCCUPANTS_COUNT.min + index);

/** Opt-in per company and only meaningful on Full usage, so it renders nothing anywhere else. */
export const VacantUnitOccupantsSelector = observer(_ref => {
  let allocationMethod = _ref.allocationMethod,
    onChange = _ref.onChange,
    vacantUnitUsage = _ref.vacantUnitUsage,
    value = _ref.value;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (!store.company.companyFeatureStore.enableVacantUnitOccupantsCount || vacantUnitUsage !== VACANT_UNIT_USAGE.NormalUsage) {
    return null;
  }
  const handleCountChange = (_event, next) => {
    if (next !== null) onChange(next);
  };
  return (
    /*#__PURE__*/
    // The parent radio row selects its level on click; picking a count must not bubble into that.
    React.createElement("div", {
      className: classes.root,
      onClick: event => event.stopPropagation()
    }, /*#__PURE__*/React.createElement(Typography, {
      id: "vacant-unit-occupants-label",
      variant: "h6"
    }, t('add_new_property_flow.vacant_unit_occupants_label')), /*#__PURE__*/React.createElement("div", {
      className: classes.counts
    }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
      "aria-labelledby": "vacant-unit-occupants-label",
      exclusive: true,
      onChange: handleCountChange,
      size: "small",
      value: value || VACANT_UNIT_OCCUPANTS_COUNT.min
    }, COUNTS.map(count => /*#__PURE__*/React.createElement(ToggleButton, {
      key: count,
      value: count,
      'custom-attribute': 'vacant-unit-occupants-count'
    }, count)))), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, t('add_new_property_flow.vacant_unit_occupants_hint')), !isOccupancyBasedAllocationMethod(allocationMethod) && /*#__PURE__*/React.createElement("div", {
      className: classes.noEffect
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "info"
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, t('add_new_property_flow.vacant_unit_occupants_no_effect'))))
  );
});